import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Grid, Button} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {InputField} from 'components/common/fields';
import {addFlashMessage} from 'actions/flash-message';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {isInteger} from 'lodash/lang';
import {PrimaryButton} from '../common/StyledButtons';
import {fetchTopics} from '../../api';
import MoreMenu from '../common/MoreMenu';


function QuizRandomizedQuestionForm(props) {

    const {initialValues, form, submitting, onSubmit} = props;
    const [topics, setTopics] = useState(null);
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [hideMoreMenu, setHideMoreMenu] = useState(true);
    const [topicInput, setTopicInput] = useState(null);
    const topicRef = useRef(null);
    const [suggestTimeout, setSuggestTimeout] = useState(null);
    const [fetchTimeout, setFetchTimeout] = useState(null);

    const handleUpdateTopicString = (e) => {
        if (suggestTimeout != null){
            clearTimeout(suggestTimeout);
            setHideMoreMenu(true);
        }
        if (fetchTimeout != null) {
            clearTimeout(fetchTimeout);
        }

        let fetchValue = e.currentTarget.value;

        setSuggestTimeout(setTimeout(() => setHideMoreMenu(false), 650));
        setTopicInput(document.querySelector('#menu-anchor'));
        setFetchTimeout(setTimeout( () => fetchAndUpdateTopics(fetchValue), 300));
        if (topicRef) { topicRef.current.focus(); }
    };

    const fetchAndUpdateTopics = (topicString) => {
        fetchTopics(topicString).then(data => setTopics(data.items.map((i) => {return {topic: i._id, count: i.count}})));
    };

    const selectMenuItem = (e) => {
        let value = (e.currentTarget.attributes.value.value);
        setSelectedTopic(value);
    };

    useEffect(() =>
        form.setFieldsValue({topic: selectedTopic != null ? selectedTopic : ''}), [selectedTopic]);

    return (
        <>
            <Grid container component="form" onSubmit={onSubmit}>
                <Grid item xs={12}>
                    <InputField
                        name="numberOfQuestions"
                        label="Number of Questions"
                        type="number"
                        rules={[
                            {required: true, message: 'Please enter the number of questions to create.'},
                            {
                                validator(rule, value, callback) {
                                    const errors = [];
                                    if (!isInteger(parseInt(value)) || parseInt(value) < 1) {
                                        errors.push('This field must be a positive number.');
                                    }
                                    callback(errors);
                                }
                            }
                        ]}
                        initialValue={initialValues['numberOfQuestions']}
                        form={form}
                        autoComplete="off"
                        variant="outlined"
                        margin="dense"
                    />
                    <InputField
                        name="topic"
                        label="Topic"
                        initialValue={initialValues['topic']}
                        rules={[
                            {required: true, message: 'Please enter a topic name'},
                        ]}
                        form={form}
                        autoComplete="off"
                        variant="outlined"
                        margin="dense"
                        onChange={handleUpdateTopicString}
                        inputRef={topicRef}
                        autoFocus={false}
                    />
                    <div id="menu-anchor"/>
                    <MoreMenu menuOpen={!hideMoreMenu && topics != null && topics.length !== 0}
                        menuOptions={topics} onClick={(e) => {setHideMoreMenu(true); selectMenuItem(e); setTopicInput(null); }}
                        anchorEl={topicInput} autoFocus={false} onClose={() => {setHideMoreMenu(true); topicRef.current.focus();}}
                        displayFunction={(option) => `${option.topic} (${option.count})`} keyFunction={(option) => `${option.topic}`}
                    />
                    <InputField
                        name="subtopic"
                        label="Subtopic (Optional)"
                        initialValue={initialValues['subtopic']}
                        form={form}
                        autoComplete="off"
                        variant="outlined"
                        margin="dense"
                    />
                </Grid>
                <Grid item xs={12}>
                    <PrimaryButton type="submit" disabled={submitting}>
                        Save
                    </PrimaryButton>
                </Grid>
            </Grid>
        </>
    );
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuizRandomizedQuestionForm.contextTypes = {
    router: PropTypes.object.isRequired
};


QuizRandomizedQuestionForm.propTypes = {
    form: formShape,
    submitting: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
};

QuizRandomizedQuestionForm.defaultProps = {
    initialValues: {},
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(createForm()(QuizRandomizedQuestionForm)));
